
import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';

function Footer() {

    const [value, setValue] = useState(0);
const matches = useMediaQuery('(min-width:1000px)');


    return (
        <Box sx={{ width: '100%',bottom:0 }}>
        <BottomNavigation
          showLabels
          value={value}
          sx={{backgroundColor:'#345C9B'}}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
     
           <BottomNavigationAction label="Recents" icon={<RestoreIcon />} />
          <BottomNavigationAction label="Favorites" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Nearby" icon={<LocationOnIcon />} /> 
        </BottomNavigation>
      </Box>
   
    );
  }
  
  export default Footer;